<div
  class="filterRadio"
  [ngClass]="{ disable: radioButtonData.value === 'DISABLED' }"
  role="radiogroup"
  [attr.aria-label]="radioButtonData.name"
>
  <div
    #radioAll
    class="filterRadio__left"
    [class.active]="radioButtonData.value === 'ALL'"
    role="radio"
    [attr.aria-checked]="radioButtonData.value === 'ALL'"
    [attr.tabindex]="radioButtonData.value === 'ALL' ? 0 : -1"
    (click)="onClick('ALL')"
    (keydown)="onKeydown($event)"
    [attr.aria-disabled]="radioButtonData.value === 'DISABLED' ? 'true' : null"
  >
    <p>egal</p>
  </div>
  <div
    #radioYes
    class="filterRadio__right"
    [class.active]="radioButtonData.value === 'YES'"
    role="radio"
    [attr.aria-checked]="radioButtonData.value === 'YES'"
    [attr.tabindex]="radioButtonData.value === 'YES' ? 0 : -1"
    (click)="onClick('YES')"
    (keydown)="onKeydown($event)"
    [attr.aria-disabled]="radioButtonData.value === 'DISABLED' ? 'true' : null"
  >
    <p class="title">{{ radioButtonData["name"] }}</p>
    <p *ngIf="showSubtitle" class="subtitle">
      ab {{ currencyFormatter(radioButtonData["minRate"]) }} mtl.
    </p>
  </div>
</div>
